<div class="container my-3 p-3 contactContent General">
  <h3 class="page-title">{{ 'ContactCertificate.PageTitle' | translate }}</h3>
  <p>{{ 'ContactCertificate.PageDescription' | translate }}</p>
  <p><strong>{{ 'ContactCertificate.PleaseConsider' | translate }}</strong></p>

  <ul>
    <div [innerHTML]="'ContactCertificate.DescriptionList2' | translate"></div>
  </ul>

  <p>{{ 'ContactCertificate.DescriptionRequest' | translate }}</p>
  <p>{{ 'ContactCertificate.DescriptionReviewed' | translate }}</p>
  <p>{{ 'ContactCertificate.RequestGiven2' | translate }}</p>
  <p [innerHTML]="'ContactCertificate.RequestQuestion' | translate"></p>
  <br>
  <h5>{{ 'ContactCertificate.TitleRequest' | translate }}</h5>
  <hr>
  <form [formGroup]="contactForm" (ngSubmit)="submit()">
    <div class="row gx-2">
      <div class="col-12 col-md-6">
        <label for="" class="form-label">{{ 'ContactCertificate.EventDate' | translate }} <span
          class="color-red">*</span></label>
        <input type="text" formControlName="eventDate" class="form-control" bsDatepicker [bsConfig]="bsConfig">
        <div class="invalid-feedback" style="display: block">
          <ng-container *ngIf="hasError('eventDate', 'required')">{{ 'ContactAssessor.Required' | translate }}
          </ng-container>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <label for="" class="form-label">{{ 'ContactCertificate.CertificateDate' | translate }} <span class="color-red">*</span></label>
        <input type="text" formControlName="certDate" class="form-control" bsDatepicker [bsConfig]="bsConfig">
        <div class="invalid-feedback" style="display: block">
          <ng-container *ngIf="hasError('certDate', 'required')">{{ 'ContactAssessor.Required' | translate }}
          </ng-container>
        </div>
      </div>
    </div>
    <br>
    <h5>{{ 'ContactCertificate.TitleHonoree' | translate }}</h5>
    <hr>
    <p class="form-label">{{ 'ContactAssessor.Name'|translate }} <span class="color-red">*</span></p>
    <div class="row gx-2">
      <div class="col-12 col-md-6">
        <input type="text" formControlName="firstName" class="form-control" id="inputFirst-Speaker" placeholder="First">
        <div class="invalid-feedback" style="display: block">
          <ng-container *ngIf="hasError('firstName', 'required')">{{ 'ContactAssessor.Required'|translate }}
          </ng-container>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <input type="text" formControlName="lastName" class="form-control" id="inputLast-Speaker" placeholder="Last">
        <div class="invalid-feedback" style="display: block">
          <ng-container *ngIf="hasError('lastName', 'required')">{{ 'ContactAssessor.Required' | translate }}
          </ng-container>
        </div>
      </div>
    </div>
    <div class="form-group" style="margin-top: 20px;">
      <label for="" class="form-label">{{ 'ContactCertificate.Organization' | translate }}</label>
      <input formControlName="organization" type="text" class="form-control">
    </div>
    <p class="form-label" style="margin-top: 20px;">{{ 'ContactCertificate.Address'| translate }}</p>

    <app-certificate-address
      [parentFormGroup]="contactForm"
      streetNumber="number"
      streetDirection="direction"
      streetName="street"
      streetType="type"
      unitNumber="unit"
      city="city"
      zipCode="zipCode"
    >
    </app-certificate-address>

    <div class="form-group" style="margin-top: 20px;">
      <label for="" class="form-label">{{ 'ContactCertificate.EventTitle' | translate }}</label>
      <input type="text" formControlName="eventTitle" class="form-control">
    </div>
    <div class="form-group" style="margin-top: 20px;">
      <label for="" class="form-label">{{ 'ContactCertificate.ReasonHonor' | translate }}<span
        class="color-red">*</span></label>
      <select formControlName="reason" name="" id="reason-honor" class="form-control">
        <option value="">Select One</option>
        <option>Retirement</option>
        <option>Memoriam</option>
      </select>
      <div class="invalid-feedback" style="display: block">
        <ng-container *ngIf="hasError('reason', 'required')">{{ 'ContactAssessor.Required' | translate }}</ng-container>
      </div>
    </div>

    <div *ngIf="retire">
      <div class="form-row" style="margin-top: 20px;">
        <div class="form-group col-md-4">
          <label for="" class="form-label">{{ 'ContactCertificate.StartDate' | translate }}<span
            class="color-red">*</span></label>
          <input type="text" formControlName="startDate" class="form-control" bsDatepicker [bsConfig]="bsConfig">
          <div class="invalid-feedback" style="display: block">
            <ng-container *ngIf="hasError('startDate', 'required')">{{ 'ContactAssessor.Required' | translate }}
            </ng-container>
          </div>
        </div>
        <div class="form-group col-md-4">
          <label for="" class="form-label">{{ 'ContactCertificate.RetirementDate' | translate }}<span class="color-red">*</span></label>
          <input type="text" formControlName="retirementDate" class="form-control" bsDatepicker [bsConfig]="bsConfig">
          <div class="invalid-feedback" style="display: block">
            <ng-container *ngIf="hasError('retirementDate', 'required')">{{ 'ContactAssessor.Required' | translate }}
            </ng-container>
          </div>
        </div>
        <div class="form-group col-md-4">
          <label for="" class="form-label">{{ 'ContactCertificate.RequestScrollDate' | translate }}<span
            class="color-red">*</span></label>
          <input type="text" formControlName="scroll" class="form-control">
          <div class="invalid-feedback" style="display: block">
            <ng-container *ngIf="hasError('scroll', 'required')">{{ 'ContactAssessor.Required' | translate }}
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="memoriam">
      <div class="form-row" style="margin-top: 20px;">
        <div class="form-group col-md-6">
          <label for="" class="form-label">{{ 'ContactCertificate.DateOfBirth' | translate }}<span
            class="color-red">*</span></label>
          <input type="text" formControlName="birthDate" class="form-control" bsDatepicker [bsConfig]="bsConfig">
          <div class="invalid-feedback" style="display: block">
            <ng-container *ngIf="hasError('birthDate', 'required')">{{ 'ContactAssessor.Required' | translate }}
            </ng-container>
          </div>
        </div>
        <div class="form-group col-md-6">
          <label for="" class="form-label">{{ 'ContactCertificate.DateOfPassing' | translate }}<span
            class="color-red">*</span></label>
          <input type="text" formControlName="passingDate" class="form-control" bsDatepicker [bsConfig]="bsConfig">
          <div class="invalid-feedback" style="display: block">
            <ng-container *ngIf="hasError('passingDate', 'required')">{{ 'ContactAssessor.Required' | translate }}
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <br>
    <h5>{{ 'ContactCertificate.Requestor' | translate }}</h5>
    <hr>
    <p class="form-label">{{ 'ContactAssessor.Name'|translate }}</p>
    <div class="row gx-2">
      <div class="col-12 col-md-6">
        <input type="text" formControlName="requestorFirstName" class="form-control" id="inputFirst-Requestor"
               placeholder="First">
        <div class="invalid-feedback" style="display: block">
          <ng-container *ngIf="hasError('requestorFirstName', 'required')">{{ 'ContactAssessor.Required'|translate }}
          </ng-container>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <input type="text" formControlName="requestorLastName" class="form-control" id="inputLast-Requestor"
               placeholder="Last">
        <div class="invalid-feedback" style="display: block">
          <ng-container *ngIf="hasError('requestorLastName', 'required')">{{ 'ContactAssessor.Required' | translate }}
          </ng-container>
        </div>
      </div>
    </div>
    <div class="form-group" style="margin-top: 20px;">
      <label for="" class="form-label">{{ 'ContactCertificate.Organization' | translate }}</label>
      <input type="text" formControlName="requestorOrg" class="form-control">
    </div>
    <div class="row">
      <div class="form-group col-md-6" style="margin-top: 20px;">
        <label for="" class="form-label">{{ 'ContactAssessor.Email' | translate }} <span
          class="color-red">*</span></label>
        <input type="text" class="form-control" formControlName="requestorEmail">
        <div class="invalid-feedback" style="display: block">
          <ng-container *ngIf="hasError('requestorEmail', 'required')">{{ 'ContactAssessor.Required' | translate }}
          </ng-container>
        </div>
      </div>
      <div class="form-group col-md-6" style="margin-top: 20px;">
        <label for="" class="form-label">{{ 'ContactAssessor.Phone' | translate }} <span
          class="color-red">*</span></label>
        <input appPhoneMask type="text" class="form-control" formControlName="requestorPhone">
        <div class="invalid-feedback" style="display: block">
          <ng-container *ngIf="hasError('requestorPhone', 'required')">{{ 'ContactAssessor.Required' | translate }}
          </ng-container>
        </div>
      </div>
    </div>
    <p class="form-label" style="margin-top: 20px;">{{ 'ContactAssessor.Address'| translate }}</p>
    <app-certificate-address
      [parentFormGroup]="contactForm"
      streetNumber="requestorNumber"
      streetDirection="requestorDirection"
      streetName="requestorStreet"
      streetType="requestorType"
      unitNumber="requestorUnit"
      city="requestorCity"
      zipCode="requestorZipCode"
    >
    </app-certificate-address>

    <div class="form-group" style="margin-top: 20px;">
      <app-file-upload formControlName="file" [progress]="progress"></app-file-upload>
      <div class="invalid-feedback" style="display: block">
        <ng-container *ngIf="hasError('file', 'required')">{{ 'ContactAssessor.Required' | translate }}</ng-container>
        <ng-container *ngIf="hasError('file', 'requiredFileType')">Only PDF, Docx</ng-container>
        <ng-container *ngIf="hasError('file', 'requiredFileSize')">Size to exceeds 10 MB</ng-container>
      </div>
    </div>
    <br>
    <h5>{{ 'ContactCertificate.DeliveryInfo' | translate }}</h5>
    <hr>
    <div>
      <label for="" class="form-label">{{ 'ContactCertificate.Method' | translate }} <span
        class="color-red">*</span></label>
      <select formControlName="method" name="" id="" class="form-select">
        <option value="">Select One</option>
        <option>Mail</option>
        <option>Pick-Up</option>
      </select>
      <div class="invalid-feedback" style="display: block">
        <ng-container *ngIf="hasError('method', 'required')">{{ 'ContactAssessor.Required' | translate }}</ng-container>
      </div>
    </div>
    <p class="form-label" style="margin-top: 20px;">{{ 'ContactAssessor.Name'|translate }} <span class="color-red">*</span></p>
    <div class="row gx-2">
      <div class="col-12 col-md-6">
        <input type="text" formControlName="deliveryFirstName" class="form-control" id="inputDeliveryFirst"
               placeholder="First">
        <div class="invalid-feedback" style="display: block">
          <ng-container *ngIf="hasError('deliveryFirstName', 'required')">{{ 'ContactAssessor.Required'|translate }}
          </ng-container>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <input type="text" formControlName="deliveryLastName" class="form-control" id="inputDeliveryLast"
               placeholder="Last">
        <div class="invalid-feedback" style="display: block">
          <ng-container *ngIf="hasError('deliveryLastName', 'required')">{{ 'ContactAssessor.Required' | translate }}
          </ng-container>
        </div>
      </div>
    </div>
    <p class="form-label" style="margin-top: 20px;">{{ 'ContactAssessor.Address'| translate }}</p>
    <app-certificate-address
      [parentFormGroup]="contactForm"
      streetNumber="deliveryNumber"
      streetDirection="deliveryDirection"
      streetName="deliveryStreet"
      streetType="deliveryType"
      unitNumber="deliveryUnit"
      city="deliveryCity"
      zipCode="deliveryZipCode"
    >
    </app-certificate-address>

    <div class="p-10" style="margin-top: 15px;">
      <re-captcha (resolved)="resolved($event)"
                  formControlName="recaptchaReactive"
                  siteKey="6LeMhXsaAAAAAJGLeSpf_zsNhZkZm8edYQwKXIwK">
      </re-captcha>
      <div class="invalid-feedback" style="display: block">
        <ng-container *ngIf="hasError('recaptchaReactive', 'required')">{{ 'ContactAssessor.Required' | translate }}
        </ng-container>
      </div>
    </div>
    <button type="submit" class="btn btn-primary mr-4" style="margin-top: 10px;">Submit</button>
    <span *ngIf="success">Successfully Submitted</span>
  </form>
</div>






